<section class="cej-what-do-i-gain">
  <article class="cej-what-do-i-gain__article">
    <h2 class="cej-what-do-i-gain__article__title">
      Mais en vrai, qu&apos;est-ce que j&apos;y gagne à long terme&nbsp;?
      <span class="line-break cej-what-do-i-gain__article__title__text"
        >Le Contrat d&apos;Engagement Jeune, c&apos;est tout bénéf&apos; pour moi&nbsp;!
      </span>
    </h2>
    <aside>
      <p>Quand je m&apos;engage, je prépare mon avenir et je mets toutes les chances de mon côté pour&nbsp;:</p>
      <ul class="cej-what-do-i-gain__article__proposal-list">
        <li>
          Définir et bâtir un
          <em class="cej-what-do-i-gain__article__proposal-list__emphasis"> projet professionnel durable</em>
        </li>
        <li>
          Mettre en valeur
          <em class="cej-what-do-i-gain__article__proposal-list__emphasis"> mes talents et mes compétences</em>
        </li>
        <li>
          <em class="cej-what-do-i-gain__article__proposal-list__emphasis">Découvrir le monde professionnel </em>
          et comprendre son fonctionnement et ses codes
        </li>
        <li>
          <em class="cej-what-do-i-gain__article__proposal-list__emphasis">Construire mon réseau </em>
          pour trouver plus facilement et plus rapidement un emploi
        </li>
      </ul>
    </aside>
  </article>
</section>
